@if (!isAddNewRequestProductFormShown) {
  <div class="flex justify-center">
    <button
      tuiButton
      type="button"
      size="m"
      (click)="showNewProductFormToAdd()"
      class="min-w-[150px]"
    >
      <tui-icon
        [style.border-width.rem]="0.25"
        icon="@tui.plus"
        class="mr-2"
      ></tui-icon>
      Добавить товар/услугу
    </button>
  </div>
} @else {
  <div class="flex justify-center">
    <div class="x-card x-card_size_m w-full md:w-2/3 lg:w-1/2 2xl:w-1/3">
      <div [formGroup]="formGroup" class="flex flex-row items-center">
        <x-request-product-selector
          class="grow"
          [formControl]="newProductField"
        ></x-request-product-selector>

        <tui-textfield
          [tuiNumberFormat]="{ precision: 0 }"
          tuiTextfieldSize="m"
          class="w-24 md:w-32 mx-3 md:mx-5 lg:mx-8"
        >
          <input
            tuiInputNumber
            [formControlName]="FormFields.NewProductAmount"
            [min]="1"
            [step]="1"
          />
        </tui-textfield>

        <button
          tuiIconButton
          type="button"
          size="l"
          (click)="addNewProductToRequest$.next()"
          [class.cursor-not-allowed]="formGroup.invalid"
          [class.cursor-pointer]="!formGroup.invalid"
          class="text-center"
          [disabled]="formGroup.invalid"
        >
          <tui-icon [style.border-width.rem]="0.25" icon="@tui.plus"></tui-icon>
        </button>
      </div>
      @if (formGroup.invalid) {
        <div class="flex flex-col">
          @if (
            newProductField.errors?.['required'] && newProductField.touched
          ) {
            <tui-error error="Выберите товар/услугу" class="ml-2"></tui-error>
          }
          @if (
            newProductAmountField.errors?.['required'] &&
            newProductAmountField.touched
          ) {
            <tui-error error="Введите количество" class="ml-2"></tui-error>
          }
        </div>
      }
      <div class="flex justify-end mt-3">
        <button
          tuiButton
          type="button"
          size="m"
          appearance="blue"
          (click)="cancelAddingNewRequestProduct()"
        >
          Отмена
        </button>
      </div>
    </div>
  </div>
}
